/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thelistingyourelookingfordoesntexist6Inputs */

const en_thelistingyourelookingfordoesntexist6 = /** @type {(inputs: Thelistingyourelookingfordoesntexist6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The listing you're looking for doesn't exist`)
};

const de_thelistingyourelookingfordoesntexist6 = /** @type {(inputs: Thelistingyourelookingfordoesntexist6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Ort gibt es nicht.`)
};

/**
* | output |
* | --- |
* | "The listing you're looking for doesn't exist" |
*
* @param {Thelistingyourelookingfordoesntexist6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const thelistingyourelookingfordoesntexist6 = /** @type {((inputs?: Thelistingyourelookingfordoesntexist6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thelistingyourelookingfordoesntexist6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thelistingyourelookingfordoesntexist6(inputs)
	return de_thelistingyourelookingfordoesntexist6(inputs)
});
export { thelistingyourelookingfordoesntexist6 as "theListingYoureLookingForDoesntExist" }